import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
    // Report
    {
        path: '/report/',
        name: 'Report',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                if (store.state.access.data.r1.read) {
                    next();
                } else {
                    next({ name: "Liveview" });
                }
            }
        },
        component: () =>
            import( /* webpackChunkName: "report" */ '@/router/views/report')
    },

    {
        path: '/report/scheduler/',
        name: 'Report Scheduler',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "report" */ '@/router/views/report/scheduler')
    },
    {
        path: '/report/scheduler/create',
        name: 'Report Scheduler Create',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "report" */ '@/router/views/report/scheduler/form')
    },
    {
        path: '/report/scheduler/update/:id',
        name: 'Report Scheduler Update',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "report" */ '@/router/views/report/scheduler/form')
    },
    {
        path: '/report/scheduler/history',
        name: 'Report Scheduler History',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "report" */ '@/router/views/report/scheduler/history')
    },
]